import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import AnswerButtonGroup from "@/components/train/AnswerButtonGroup.vue";
export default {
  name: "StereoSameEdgeRender",
  components: {
    AnswerButtonGroup
  },
  props: {
    review: {
      type: Object,
      default: () => null
    },
    reviewMode: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    netCells() {
      return Array.isArray(this.data?.net) ? this.data.net : [];
    },
    bounds() {
      if (this.netCells.length === 0) return {
        minX: 0,
        minY: 0,
        maxX: 0,
        maxY: 0
      };
      let minX = this.netCells[0].x;
      let minY = this.netCells[0].y;
      let maxX = this.netCells[0].x;
      let maxY = this.netCells[0].y;
      this.netCells.forEach(c => {
        minX = Math.min(minX, c.x);
        minY = Math.min(minY, c.y);
        maxX = Math.max(maxX, c.x);
        maxY = Math.max(maxY, c.y);
      });
      return {
        minX,
        minY,
        maxX,
        maxY
      };
    },
    cellSize() {
      return 80;
    },
    padding() {
      return 10;
    },
    svgW() {
      return (this.bounds.maxX - this.bounds.minX + 1) * this.cellSize + this.padding * 2;
    },
    svgH() {
      return (this.bounds.maxY - this.bounds.minY + 1) * this.cellSize + this.padding * 2;
    },
    arrowLen() {
      return this.cellSize * 0.6;
    },
    options() {
      return this.data?.options?.length ? this.data.options : ['true', 'false'];
    },
    optionLabelMap() {
      return {
        true: '能',
        false: '不能'
      };
    },
    optionLabelList() {
      return this.options.map(op => this.optionLabelMap[op] || op);
    },
    arrowAInfo() {
      return this.arrowInfo(this.data?.arrowA);
    },
    arrowBInfo() {
      return this.arrowInfo(this.data?.arrowB);
    }
  },
  methods: {
    onChoosed(list) {
      this.$emit('answer', list && list.length > 0 ? list[0] : null);
    },
    labelFor(value) {
      return this.optionLabelMap[value] || value;
    },
    cellDraw(cell) {
      return {
        x: (cell.x - this.bounds.minX) * this.cellSize + this.padding,
        y: (cell.y - this.bounds.minY) * this.cellSize + this.padding
      };
    },
    arrowInfo(arrow) {
      if (!arrow) return null;
      const cell = this.netCells.find(c => c.id === arrow.cellId);
      if (!cell) return null;
      const pos = this.cellDraw(cell);
      const cx = pos.x + this.cellSize / 2;
      const cy = pos.y + this.cellSize / 2;
      const angle = this.dirToAngle(arrow.dir);
      return {
        cx,
        cy,
        angle
      };
    },
    dirToAngle(dir) {
      if (dir === 'N') return -90;
      if (dir === 'E') return 0;
      if (dir === 'S') return 90;
      if (dir === 'W') return 180;
      return 0;
    },
    arrowTransform(info) {
      return `translate(${info.cx}, ${info.cy}) rotate(${info.angle})`;
    }
  }
};